
import React from 'react';
import Gradient from '@/assets/medihub_gradient_mesh.jpg';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';
import { useAuth } from '@/contexts/auth/AuthContext';

interface CalendarPageHeaderProps {
  handleNavigateToRegister: () => void;
}

const CalendarPageHeader: React.FC<CalendarPageHeaderProps> = ({
  handleNavigateToRegister
}) => {
  const {
    isAuthenticated
  } = useAuth();

  return (
    <div className="relative overflow-hidden rounded-xl mb-8">
      <div className="absolute inset-0 z-0">
        <img src={Gradient} alt="MediHub gradient háttér" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/10 z-0"></div>
      </div>

      <div className="relative z-10 p-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-4">
          <div>
            <h1 className="text-3xl font-bold text-white mb-2">Eseménynaptár</h1>
            <p className="text-white/90 max-w-2xl">
              Böngéssz az egészségügyi továbbképzések, konferenciák és események között. Szűrj szakterületek, helyszín vagy típus szerint.
            </p>
          </div>
        </div>
        {!isAuthenticated && (
          <Button onClick={handleNavigateToRegister} className="bg-medihub-accent mb-4 hover:bg-medihub-accent/90 text-white shadow-md flex items-center gap-2">
            <UserPlus className="w-4 h-4" />
            Regisztráció résztvevőként
          </Button>
        )}

        <p className="text-sm text-white/80 italic">
          Tartsd számon az összes fontos eseményt egy helyen, és szerezz értesítéseket az érdeklődési körödnek megfelelő eseményekről.
        </p>
      </div>
    </div>
  );
};

export default CalendarPageHeader;
